export default __webpack_public_path__ + "static/media/logo_ba_wh.8b10a013.png";